<template>
	<hr :class="['divider', ...variantClassList]" />
</template>

<script>
import componentVariantMixin from '@/mixins/component-variant-mixin';
import variantClasses from './variant-classes/divider-variant-classes';

export default {
	name: 'Divider',
	mixins: [componentVariantMixin],
	created() {
		this.variantClasses = variantClasses;
	}
};
</script>

<style lang="scss" scoped>

.divider {
	display: inline-block;
	width: calc(100% - #{$padding-md});
	margin-block-start: 0;
	margin-block-end: 0;
	margin-inline-start: auto;
	margin-inline-end: auto;
	border: 0;
	height: 1px;
	background: $neutral-4;

	&--vertical {
		width: 1px;
		height: calc(100% - #{$padding-md});
	}
}
</style>
